import { HomeOutlined, TransactionOutlined } from '@ant-design/icons';

import { withNavigation } from 'containers/Navigation';

import { Transactions } from 'routes/transactions/Transactions';

import { IRoute, Item } from 'types/common';

import { FrontCreate } from './FrontCreate';
import { FrontSingleView } from './FrontSingleView';
import { FrontView } from './FrontView';
import { FrontViewInvoice } from './FrontViewInvoice';
import { FrontViewUuid } from './FrontViewUuid';
import { Home } from './Home';
import { ObituaryPreview } from './ObituaryPreview';

export const route: IRoute = {
  component: withNavigation(Home),
  exact: true,
  isPrivate: true,
  key: 'home',
  path: '/administracija',
};

export const routeFront: IRoute = {
  component: FrontView,
  exact: true,
  isPrivate: false,
  key: 'home',
  path: '/',
};

export const routeFrontInvoice: IRoute = {
  component: FrontViewInvoice,
  exact: true,
  isPrivate: false,
  key: 'invoice',
  path: '/invoice/:id',
};

export const routeFrontUuid: IRoute = {
  component: FrontViewUuid,
  exact: true,
  isPrivate: false,
  key: 'home',
  path: '/placanje/:uuid',
};

export const routeFrontCreate: IRoute = {
  component: FrontCreate,
  exact: true,
  isPrivate: false,
  key: 'home',
  path: '/objavi',
};

export const routeFrontEdit: IRoute = {
  component: FrontView,
  exact: true,
  isPrivate: false,
  key: 'home',
  path: '/smrtovnica/:ime/:id',
};

export const routeFrontSingle: IRoute = {
  component: FrontSingleView,
  exact: true,
  isPrivate: false,
  key: 'home',
  path: '/smrtovnica/:id',
};

export const previewRoute: IRoute = {
  component: ObituaryPreview,
  exact: true,
  isPrivate: false,
  key: 'home',
  path: '/prikaz/:id',
};

export const transactionRoute: IRoute = {
  component: withNavigation(Transactions),
  exact: true,
  isPrivate: true,
  key: 'Transakcije',
  path: '/transactions',
};

export const item: Item = {
  key: route.key,
  path: route.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const itemFront: Item = {
  key: routeFront.key,
  path: routeFront.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const itemFrontEdit: Item = {
  key: routeFrontEdit.key,
  path: routeFrontEdit.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const itemFrontSingle: Item = {
  key: routeFrontSingle.key,
  path: routeFrontSingle.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const previewItem: Item = {
  key: previewRoute.key,
  path: previewRoute.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const itemFrontCreate: Item = {
  key: routeFrontCreate.key,
  path: routeFrontCreate.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const itemFrontUuid: Item = {
  key: routeFrontUuid.key,
  path: routeFrontUuid.path as string,
  icon: HomeOutlined,
  rank: 1,
};

export const transactionItem: Item = {
  key: transactionRoute.key,
  path: transactionRoute.path as string,
  icon: TransactionOutlined,
  rank: 1,
};
